import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CognitoService } from "../../shared/services/cognito.service";
import { AvatarRegion, Campaign, Label } from "../../../models";
import { GetGroupsByParamsRequest, GetGroupsByParamsResponse } from "../model/get-groups-by-params.model";

@Injectable({
    providedIn: 'root'
})
export class CreateCampaignApiService {
    constructor(
        private httpClient: HttpClient,
        private cognitoService: CognitoService
    ) {}

    getGroupsByParams(params: GetGroupsByParamsRequest): Observable<GetGroupsByParamsResponse> {
        return this.httpClient.post<GetGroupsByParamsResponse>(this.cognitoService.appUri + '/get-groups-by-params', params);
    }

    postNewCampaign(campaign: Campaign): Observable<string> {
        return this.httpClient.post<string>(this.cognitoService.appUri + '/campaign-create', campaign);
    }

    getAvatarsRegion$(): Observable<AvatarRegion[]> {
        return this.httpClient.get<AvatarRegion[]>(this.cognitoService.appUri + '/avatars-region');
    }

    getLabels(): Observable<Label[]> {
        return this.httpClient.get<Label[]>(this.cognitoService.appUri + '/get-labels');
    }

    getGroupsByLabelIds(labelIds: number[]): Observable<{ GroupUser: string; Restrictions: string }[]> {
        return this.httpClient.get<{ GroupUser: string; Restrictions: string }[]>(
            this.cognitoService.appUri + '/get-groups-by-labels',
            { params: { group_label_ids: `[${labelIds.join(',')}]` } }
        );
    }

    getGroupRegions$(groupId: string): Observable<string[]> {
        return this.httpClient.get<string[]>(this.cognitoService.appBotanicUri + '/get-group-regions', {
            params: { external_entity_id: groupId }
        });
    }

    countAvatarsInGroup$(application_id: string, group_id: string, owner_unit_id: string, region_id: string,
                         gender?: string, ageFrom?: number, ageTo?: number, minHoursSinceJoin?: number): Observable<number> {
        let params: any = { application_id, group_id, owner_unit_id, region_id };
        if (gender) params.gender = gender;
        if (ageFrom != null) params.age_from = ageFrom.toString();
        if (ageTo != null) params.age_to = ageTo.toString();
        if (minHoursSinceJoin != null) params.min_hours_since_join = minHoursSinceJoin.toString();
        return this.httpClient.get<number>(this.cognitoService.appBotanicUri + '/count-avatars-in-group', { params });
    }

    countAvatarsInGroups$(application_id: string, group_ids: string[], owner_unit_id: string, region_id: string,
                          gender?: string, ageFrom?: number, ageTo?: number, minHoursSinceJoin?: number): Observable<Record<string, number>> {
        let params: any = { application_id, group_ids: group_ids.join(','), owner_unit_id, region_id };
        if (gender) params.gender = gender;
        if (ageFrom != null) params.age_from = ageFrom.toString();
        if (ageTo != null) params.age_to = ageTo.toString();
        if (minHoursSinceJoin != null) params.min_hours_since_join = minHoursSinceJoin.toString();
        return this.httpClient.get<Record<string, number>>(this.cognitoService.appBotanicUri + '/count-avatars-in-group', { params });
    }

    countAvatars$(application_id: string, owner_unit_id: string, region_id: string,
                  gender?: string, ageFrom?: number, ageTo?: number): Observable<number> {
        let params: any = { application_id, region_id, owner_unit_id };
        if (gender) params.gender = gender;
        if (ageFrom != null) params.age_from = ageFrom.toString();
        if (ageTo != null) params.age_to = ageTo.toString();
        return this.httpClient.get<number>(this.cognitoService.appBotanicUri + '/count-avatars', { params });
    }

    generateCommentsAI(prompt: string, commentsCount: number, language: string): Observable<string[]> {
        return this.httpClient.post<string[]>(this.cognitoService.appUri + '/ai-generate-comments', {
            prompt,
            comments_count: commentsCount,
            language
        });
    }

}
